import React, {
    useState, forwardRef,
    useEffect, useLayoutEffect, useImperativeHandle
} from 'react';

const isReady = () => typeof window !== 'undefined'
    && typeof window.grecaptcha !== 'undefined'
    && typeof window.grecaptcha.render === 'function';


export default forwardRef(({
   elementID = 'g-recaptcha',
   onloadCallback,
   onloadCallbackName = 'onloadCallback',
   verifyCallback,
   verifyCallbackName = 'verifyCallback',
   expiredCallback,
   expiredCallbackName = 'expiredCallback',
   className = 'g-recaptcha',
   sitekey,
   theme = 'light',
   type = 'image',
   size = 'normal',
   tabindex = '0',
   hl,
   badge = 'bottomright',
}, ref) => {

    const [ready, setReady] = useState(isReady());
    const [widget, setWidget] = useState(null);

    useImperativeHandle(ref, () => ({
        reset: () => {
            if (ready && widget !== null) {
                window.grecaptcha.reset(widget);
            }
        },
        execute: () => {
            if (ready && widget !== null) {
                window.grecaptcha.execute(widget);
            }
        }
    }));

    useEffect(()=>{
        if (!ready && typeof window !== 'undefined') {
            // console.log('checktimer start')
            const readyCheck = setInterval(()=>{
                if (isReady()) {
                    setReady(true)
                    clearInterval(readyCheck);
                }
            }, 1000);
            return () => clearInterval(readyCheck);
        }
    }, [ready]);

    useLayoutEffect(()=>{
        if (onloadCallback && ready) {

            // console.log('_renderGrecaptcha')
            const _widget = window.grecaptcha.render(elementID, {
                sitekey: sitekey,
                callback: (verifyCallback) ? verifyCallback : undefined,
                theme: theme,
                type: type,
                size: size,
                tabindex: tabindex,
                hl: hl,
                badge: badge,
                'expired-callback': (expiredCallback) ? expiredCallback : undefined,
            });

            setWidget(_widget);

            if (onloadCallback) {
                onloadCallback();
            }

        }
    }, [ready]);

    return (
        <div id={elementID}
             data-onloadcallbackname={onloadCallbackName}
             data-verifycallbackname={verifyCallbackName}
        />
    );
});